// @flow
import cn from 'classnames';
import React from 'react';
import { injectIntl } from 'react-intl';

import type { SocialLinkComponent } from '#common/flow-types/components';
import type { IntlShape } from 'react-intl';

import './style.pcss';

const svgByName = (name: string): string => {
  try {
    return require(`../../../assets/images/socials/icons/${name}.svg`); // eslint-disable-line
  } catch (error) {
    return '';
  }
};


type Props = {
  socialComponent: SocialLinkComponent,
  checkLinkExist: Function,
  intl: IntlShape,
  blockName: string,
  className: string
}

const Social = ({
  socialComponent, checkLinkExist, intl, blockName, className
}: Props) => {
  const { length } = socialComponent.value.filter(c => c.enable === true);
  if (!length) {
    return null;
  }

  const socialsWithinTwitch = socialComponent.value.filter(component => component.name === 'twitch');
  if (socialsWithinTwitch.length === 0) {
    socialComponent.value.push({
      name: 'twitch',
      url: '',
      enable: false
    });
  }

  return (
    <ul className={cn('ui-site-social-icon-list', `ui-site-social-icon-list--${className}`)}>
      {socialComponent.value.map(social => {
        if (!social.enable) {
          return null;
        }
        return (
          <li
            key={social.name}
            className='ui-site-social-icon-list__item'
          >
            {social.url === '' && (
              <button
                className='ui-site-social-icon'
                dangerouslySetInnerHTML={{ __html: svgByName(social.name) }}  // eslint-disable-line
                onClick={() => checkLinkExist(social.url)}
                data-xa-method='elementClick'
                data-xa-name={social.name}
                data-xa-value={social.url}
                title={intl.messages[`nav_block.${blockName}_settings.toggle_${social.name}`]}
              />
            )}
            {social.url !== '' && (
              <a
                href={social.url}
                rel='noopener noreferrer'
                target='_blank'
                className='ui-site-social-icon'
                dangerouslySetInnerHTML={{ __html: svgByName(social.name) }}  // eslint-disable-line
                onClick={() => checkLinkExist(social.url)}
                data-xa-method='elementClick'
                data-xa-name={social.name}
                data-xa-value={social.url}
                title={intl.messages[`nav_block.${blockName}_settings.toggle_${social.name}`]}
              />
            )}
          </li>
        );
      })
      }
    </ul>
  );
};

export default injectIntl(Social);
